// extracted by mini-css-extract-plugin
export default {"recordDrawer":"maintenanceRecord_recordDrawer__OgcOU"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"recordDrawer\":\"maintenanceRecord_recordDrawer__OgcOU\"}";
        // 1793842504244
        var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  